import { AsyncReturnType } from "type-fest";

import { CrmService } from "@/services";
import { UseMutationSimpleOptions, useMutation } from "@/services/hooks";

type Variables = Parameters<typeof CrmService.updateContact>[0];
type Data = AsyncReturnType<typeof CrmService.updateContact>;
type Error = unknown;

export const useUpdateContact = <TContext = unknown>(
  options?: UseMutationSimpleOptions<Data, Error, Variables, TContext>
) => {
  const result = useMutation<Data, Error, Variables, TContext>(
    CrmService.updateContact,
    options
  );

  return result;
};
